import {createReducer} from '@reduxjs/toolkit';

import {CompleteOrderType} from 'types/completeOrderType';

import {
    completeOrderReview,
    completeOrderReviewPaypal,
    completeOrderReviewPending,
    completeOrderReviewResetPending,
    setDefaultStateForCompleteOrder,
    setPlaceOrderErrors,
} from '../../actions/completeOrder/completeOrder';

export const initialState: CompleteOrderType = {
    error: false,
    error_messages: '',
    go_to: '',
    order_id: '',
    status: '',
    success: false,
};

/**
 * Payment info (card number, month, year), send to backend and save store
 */
export const completeOrder = createReducer(initialState, builder =>
    builder
        .addCase(completeOrderReview.fulfilled, (state, action) => ({
            ...state,
            ...action.payload.data,
        }))
        .addCase(completeOrderReviewPaypal.fulfilled, (state, action) => ({
            ...state,
            ...action.payload.data,
        }))
        .addCase(completeOrderReview.pending, state => ({
            ...state,
            status: 'pending',
        }))
        .addCase(completeOrderReviewPaypal.pending, state => ({
            ...state,
            status: 'pending',
        }))
        .addCase(completeOrderReviewPending, state => ({
            ...state,
            status: 'pending',
        }))
        .addCase(completeOrderReviewResetPending, state => ({
            ...state,
            status: '',
        }))
        .addCase(completeOrderReview.rejected, (state, action) => ({
            ...state,
            ...action.payload?.response?.data,
            status: 'rejected',
        }))
        .addCase(completeOrderReviewPaypal.rejected, (state, action) => ({
            ...state,
            ...action.payload?.response?.data,
            status: 'rejected',
        }))
        .addCase(setPlaceOrderErrors, (state, {payload}) => ({...state, errors: payload}))
        .addCase(setDefaultStateForCompleteOrder, () => initialState),
);
